import React, {useState} from 'react';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import {Modal} from 'react-bootstrap';
import {FieldArray} from 'formik';
import DataItem from '../../_common/components/DataItem';
import {usePopupSplitLinesContext} from '../contexts/PopupSplitLinesContext';
import styles from './styles.module.scss';

const PopupSplitLine = ({receiptLineId}) => {
  const [show, setShow] = useState(false);
  const handleShowModal = () => setShow(true);
  const handleCloseModal = () => setShow(false);

  const {formik, totalAmount, handleSplit} = usePopupSplitLinesContext();
  const {values} = formik;

  const totalSubtract = values.amounts.length > 1
    ? values.amounts.map((item, index) => {
      if (index !== 0) {
        return Boolean(item.amount) ? parseFloat(item.amount) : 0;
      } else return 0;
    }).reduce((acc, value) => acc + value, 0) : 0;
  const firstAmount = totalAmount - totalSubtract;

  return (
    <>
      <div onClick={handleShowModal} style={{fontSize: '16px', cursor: 'pointer'}}>🔀</div>
      <Modal show={show} onHide={handleCloseModal}>
        <Modal.Body className={styles.modalContainer}>
          <h3 className={styles.headerText}>
            <FormattedMessage
              id={'transfersByAgent-popup-split-lines-header'}
              defaultMessage={'Split receipt line - {id}'}
              values={{id: receiptLineId}}
            />
          </h3>
          <div>
            <FieldArray name={'amounts'}>
              {({remove, push}) => {
                return (
                  <>
                    {(values.amounts.length > 0) && values.amounts.map((sets, index) => (
                      <div key={index} className="d-flex align-items-center py-2 mx-auto w-50 border-bottom">
                        <DataItem
                          fieldId={`amounts[${index}].amount`}
                          value={index === 0 ? firstAmount : values.amounts[index].amount}
                          containerStyle={'w-100'}
                          disabled={index === 0}
                          dir={'ltr'}
                          customInputStyle={classNames('text-left', styles.fieldInput)}
                        />
                        {index !== 0 && <span className={'cursor-pointer font-size-lg'} onClick={() => remove(index)}>🗑</span>}
                      </div>
                    ))}
                    <button
                      className={classNames(styles.secondary, 'd-block mx-auto')}
                      onClick={() => push({amount: ''})}
                    >
                      ➕
                    </button>
                  </>
                );
              }}
            </FieldArray>
            <div className={styles.actions}>
              <button className={styles.btnCancel} onClick={handleCloseModal}>
                <FormattedMessage id={'label-button-cancel'} defaultMessage={'Cancel'}/>
              </button>
              <button disabled={!formik.isValid}
                      className={styles.primary}
                      onClick={async () => {
                        await handleSplit(receiptLineId, firstAmount);
                        handleCloseModal();
                      }}
              >
                <FormattedMessage id={'label-button-confirm'} defaultMessage={'Confirm'}/>
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PopupSplitLine;